import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class ProprietaryMetricsService extends Service {
  constructor(gateway) {
    const api = createApi('/proprietary-metrics', gateway, {
      authNotFound: () => true,
    });
    super(api, { afterParser });
  }

  engagementMatrixPosts(params = {}) {
    return this.find({
      ...params,
      url: '/engagement-matrix/posts',
    });
  }

  engagementMatrixTags(params = {}) {
    return this.find({
      ...params,
      url: '/engagement-matrix/tags',
    });
  }
}

export default new ProprietaryMetricsService(gateway);
